import PropTypes from 'prop-types';
import { FaRegFileAlt, FaFileAlt } from 'react-icons/fa';

import { useWorkReportModals } from '../../../../context/WorkReportModalsContext';
import { attachmentFileColorIcon } from '../../../../constants/constants';
import { checkRol } from '../../../../security';
import { notificador, proveedorNotificador, inspector } from '../../../../security/constantsRols';
import { Line } from '../../../../utils/globalPropTypes';

const FilesWorkReportButton = (props) => {
  const {
    line,
    startDate,
    monthly,
    canVisualizeFiles,
    canAttachFiles,
    setNewFetch,
    disabledEditStateCancelOrFinish
  } = props;
  const { activeAttachFileModal } = useWorkReportModals();
  const isLineBlockedBySap =
    line?.bloqueadoEnSap && (checkRol(proveedorNotificador) || checkRol(notificador));

  const setColorAattachedDocument = () => {
    if (isLineBlockedBySap) {
      return '#DDDDDD';
    }
    // If evidence is required — red border
    if (line.archivoAdjunto === attachmentFileColorIcon.requiredAttachmentFile) return '#FF6666';
    // If provider, notifier — when enabled, blue border
    if (line.archivoAdjunto === attachmentFileColorIcon.enabled && checkRol(proveedorNotificador))
      return '#159AD8';
    // If notifier — when enabled, black border
    if (
      (line.archivoAdjunto === attachmentFileColorIcon.enabled && checkRol(notificador)) ||
      (line.estadoRevision?.adjuntar && checkRol(inspector))
    )
      return '#575757';

    return '#DDDDDD';
  };

  return (
    <button
      className="button_work_report"
      disabled={
        !canVisualizeFiles ||
        line.archivoAdjunto === attachmentFileColorIcon.disabled ||
        isLineBlockedBySap
      }
      onClick={() => {
        activeAttachFileModal(
          {
            ...line,
            startDate,
            monthly
          },
          () => setNewFetch((oldFetch) => !oldFetch),
          !canAttachFiles || !line.estadoRevision?.adjuntar || disabledEditStateCancelOrFinish
        );
      }}
      style={{
        color: setColorAattachedDocument()
      }}
      type="button"
    >
      {line.archivoAdjunto === attachmentFileColorIcon.hasAttachmentFile ? (
        <div
          style={{
            color: '#159AD8'
          }}
        >
          <FaFileAlt />
        </div>
      ) : (
        <FaRegFileAlt />
      )}
    </button>
  );
};

FilesWorkReportButton.propTypes = {
  canVisualizeFiles: PropTypes.bool,
  canAttachFiles: PropTypes.bool,
  line: Line.isRequired,
  startDate: PropTypes.string.isRequired,
  monthly: PropTypes.bool,
  setNewFetch: PropTypes.func,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired
};

FilesWorkReportButton.defaultProps = {
  canVisualizeFiles: true,
  canAttachFiles: true,
  monthly: false,
  setNewFetch: () => {}
};

export default FilesWorkReportButton;
